var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"Nav__logo",attrs:{"active-class":"","to":_vm.logo.to,"title":"Website Logo","aria-label":"Website logo"}},[_c('img',{attrs:{"src":require(("@/assets/images/" + (_vm.logo.image))),"alt":"Website Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }